<script>
import AnnouncementsApi from "@/services/announcements-api";
import {Languages} from "./languages";

export default {
      components: {
      },
      mounted(){
        this.getHighlights()
      },
      data() {
        return {
          highlightsList:[],
          showModal:false,
          selectedAnnouncment:{id:null,title:'',date:'',description:''},
          pagemodel: {currentPage : 1, perPage :4, totalRows: 0},
        languages:Languages,
        }
      },
      methods:{
        getHighlights(){
        //    if((this.pagemodel.totalRows-(this.pagemodel.currentPage+1))<(this.pagemodel.pageSize-1) || (this.pagemodel.currentPage-1<=0)){
        //     return ;
        //   }

        this.pagemodel.perPage = window.innerWidth < 990 ? 1 : 4;
        
        AnnouncementsApi.getHighlights(this.pagemodel.currentPage, this.pagemodel.perPage)
            .then(result => {
              if(result){
                this.highlightsList=result.list;
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
              }
            })
        },
        increaseCurrentPage(){
            if((this.pagemodel.totalRows-(this.pagemodel.currentPage+1))<(this.pagemodel.pageSize-1)){
                return
            }
            this.pagemodel.currentPage+=1
        },
        decreaseCurrentPage(){
            if(this.pagemodel.currentPage-1<=0){
                return
            }
            this.pagemodel.currentPage-=1
        }
      }
}
</script>
<template>
    <div class="pl-4 pr-4 pt-4 pb-4" v-if="highlightsList && highlightsList.length">
        <section class="section" id="news" style="background-color: rgba(254, 194, 53, 0.19)">
            <div class="row">
                <div class="col-lg-12">
                <div class="text-center  pt-2">
                    <div class="small-title text-primary">{{$t('highlights.smallTitle')}} </div>
                    
                    <div class="row">
                        <div class="col-2 text-left pl-4">
                            <b-button variant="light" @click="decreaseCurrentPage();getHighlights()" :class="pagemodel.currentPage-1<=0 ?'d-none' : ''"><i class="fas fa-angle-double-left"/></b-button>
                        </div>
                        <div class="col-8">
                            <h4 class="text-primary"> {{$t('highlights.title')}}   </h4>
                        </div>
                        <div class="col-2 text-right pr-4">
                            <b-button variant="light" @click="increaseCurrentPage();getHighlights()" :class="(pagemodel.totalRows-(pagemodel.currentPage+1))<(pagemodel.pageSize-1) ? 'd-none' : ''"><i class="fas fa-angle-double-right"/></b-button>
                        </div>
                    </div> 
                </div>
                </div>
            </div>
            <!-- end row -->
                

          
                    <div class="row pb-4">
                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-3 pl-4 pr-4 pt-2 "  v-for="(announcement) in this.highlightsList" :key="announcement.id">

                            <div class="card p-1 border border-warning shadow-none h-100">
                                <div class="p-3">
                                    <h5 :id="'tooltip-top' + announcement.id" class="text-primary truncate-title" @click="showModal=true;selectedAnnouncment=announcement" style="cursor:pointer">
                                       {{$t('current_language')==languages[0]["frensh"] ? announcement.title : $t('current_language')==languages[0]["english"] ? announcement.titleEn : announcement.title}}
                                    </h5>

                                    <p class="text-muted mb-0">{{announcement.date}}</p>
                                </div>

                            <div class="position-relative">
                                <img
                                :src="'/api/image/get/' + announcement.image"
                                alt=""
                                style="max-height:28em;min-height:28em; cursor:pointer"
                                class="img-thumbnail w-100"
                                
                                @click="showModal=true;selectedAnnouncment=announcement"
                                />
                            </div>

                            <div class="p-3">
                                <ul class="list-inline">
                                <li class="list-inline-item me-3">
                                    <a href="javascript:void(0);" class="text-muted">
                                    <i
                                        class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                                    ></i>
                                        {{$t('current_language')==languages[0]["frensh"] ? announcement.tag : $t('current_language')==languages[0]["english"] ? announcement.tagEn : announcement.tag}}                                    </a>
                                </li>
                                </ul>
                                <p  v-html="$t('current_language')==languages[0]['frensh'] ? announcement.description : $t('current_language')==languages[0]['english'] ? announcement.descriptionEn : announcement.description" style="min-height: 10em;max-height: 10em; overflow: hidden;" class="text-justify ">

                                </p>

                                <div>
                                <a href="javascript:void(0);" class="text-primary" @click="showModal=true;selectedAnnouncment=announcement"
                                    >{{$t('highlights.seeMore')}} <i class="mdi mdi-arrow-right"></i
                                ></a>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>


        <b-modal
            v-model="showModal"
            v-if="selectedAnnouncment.id"
            :title="$t('current_language')==languages[0]['frensh'] ? selectedAnnouncment.title : $t('current_language')==languages[0]['english'] ? selectedAnnouncment.titleEn : selectedAnnouncment.title"
            hide-footer
            centered
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            scrollable
            size="xl">

            <b-row no-gutters class=" pr-2">
                <b-col md="3"  >
                    <b-card-img :src="'/api/image/get/' + selectedAnnouncment.image" class="rounded-4  border border-primary" style="border-radius: 5px;max-height:28em;min-height:28em"></b-card-img>
                </b-col>

                <b-col md="9" class="pl-0 pl-sm-2 mt-4 mt-md-0 mt-lg-0 mt-xl-0 mt-sm-0"  >
                    <div class="card h-100 w-100 ">
                    <div class="card-body pt-0">
                        <div class="media">
                        <div class="media-body overflow-hidden">
                            <span  v-html="$t('current_language')==languages[0]['frensh'] ? selectedAnnouncment.description : $t('current_language')==languages[0]['english'] ? selectedAnnouncment.descriptionEn : selectedAnnouncment.description"   class="text-justify "> </span>
                        </div>
                        </div>
                    </div>
                    <div class="px-4 py-3 border-top">
                        <b-row>
                        <b-col xs="6">
                            <i class="bx bx-calendar me-1"></i>
                            {{selectedAnnouncment.date}}
                        </b-col>
                        <b-col xs="6" class="text-right d-none d-sm-block">
                            <router-link tag="a" to="/" v-if="($t('current_language')==languages[0]['frensh'] && selectedAnnouncment.tag) || ($t('current_language')==languages[0]['english'] && selectedAnnouncment.tagEn) ">
                            <span 
                                :class="selectedAnnouncment.type==0 ? 'badge bg-danger text-white font-size-15' : 'badge bg-warning text-primary font-size-15'"
                                ><span > <strong>{{$t('current_language')==languages[0]["frensh"] ? selectedAnnouncment.tag : $t('current_language')==languages[0]["english"] ? selectedAnnouncment.tagEn : selectedAnnouncment.tag}}</strong> </span>
                                
                                </span
                            >
                            </router-link>
                        </b-col>
                        </b-row>
                    </div>
                    </div>
                </b-col>
            </b-row>

        </b-modal>
    </div>
</template>
<style >
.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}
</style>